const MODULES = {
  //DASHBOARD:          "Dashboard",
  // SETTINGS:           "Settings",
  // MY_COMPANY:         "My Company",
  SALE_INVOICE:       "Sale Invoice",
  INVOICE_POS:        "Invoice POS",
  ESTIMATE_QUOTATION: "Estimate Quotation",
  ADD_ITEM:           "Add Item",
  VIEW_ITEM:          "View Item",
  CUSTOMER:           "Customer",
  PARTIES:            "Parties",
  STOCK_ADJUSTMENT:   "Stock Adjustment",
};

export default MODULES;